import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import StudentSidebar from "../common/studentSidebar";
import ProfileCard from "../common/profileCard";
import ForumCard from "../common/forumCard";
import { useHandleForum } from "../../../core/hooks/useHandleForum";
import { Pagination } from "../../../core/common/ults/pagination";
import Skeleton from "react-loading-skeleton";
import { useAuth } from "../../../core/hooks/useAuth";
import { useHandleCourses } from "../../../core/hooks/useHandleCourses";
import { Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const StudentForums = () => {
  const { t } = useTranslation();
  const { moodleUser } = useAuth();
  const { enrolledCourses, isEnrolledCoursesLoading, typeEnrol, isTypeEnrol } = useHandleCourses(
    moodleUser?.id
  );
  const [selectedCourse, setSelectedCourse] = useState<{
    id: number;
    fullname: string;
  } | null>(null);
  const [courseSearch, setCourseSearch] = useState("");
  const { allForums, isAllForumsLoading, refetchAllForums } = useHandleForum(selectedCourse?.id);

  useEffect(() => {
    refetchAllForums();
  }, [refetchAllForums]);

  const courseList = Array.isArray(enrolledCourses) ? enrolledCourses : [];

  const filteredCourses = useMemo(() => {
    const keyword = courseSearch.trim().toLowerCase();
    if (!keyword) return courseList;
    return courseList.filter((course: any) =>
      String(course.fullname ?? "").toLowerCase().includes(keyword)
    );
  }, [courseList, courseSearch]);

  const itemsPerPage = 4; // Số lượng courses hiển thị trên mỗi trang
  const [currentPage, setCurrentPage] = useState(1);

  // Tính toán dữ liệu hiển thị
  const startIndex = (currentPage - 1) * itemsPerPage;
  const forumsArray = Array.isArray(allForums) ? allForums.filter((forum: any) => forum.numdiscussions > 0) : [];
  const currentForums = forumsArray.slice(startIndex, startIndex + itemsPerPage);

  return (
    <>
      <div className="content">
        <div className="container">
          {/* profile box */}
          <ProfileCard />
          {/* profile box */}
          <div className="row">
            {/* sidebar */}
            <StudentSidebar />
            {/* sidebar */}
            <div className="col-lg-9">
              <Breadcrumb title={t("sidebarMenu.forum")} />
              <div className="page-title d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 gap-md-0">
                <h5>{t("sidebarMenu.forum")}</h5>
                <Select
                  style={{ width: 240 }}
                  placeholder={t("student.events.allCourses")}
                  value={selectedCourse?.id ?? "all"}
                  onChange={(courseId) => {
                    if (!courseId || courseId === "all") {
                      setSelectedCourse(null);
                      return;
                    }
                    const course = courseList.find(
                      (c: any) => c.id === courseId
                    );
                    setSelectedCourse(
                      course
                        ? { id: course.id, fullname: course.fullname }
                        : null
                    );
                  }}
                  onDropdownVisibleChange={(open: boolean) => {
                    if (!open) setCourseSearch("");
                  }}
                  dropdownRender={(menu) => (
                    <>
                      <div
                        style={{ padding: "8px 8px 4px" }}
                        onMouseDown={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <Input
                          allowClear
                          prefix={<SearchOutlined />}
                          placeholder={t("message.search")}
                          value={courseSearch}
                          onChange={(e) => setCourseSearch(e.target.value)}
                          onKeyDown={(e) => e.stopPropagation()}
                        />
                      </div>
                      {menu}
                    </>
                  )}
                  options={[
                    {
                      value: "all",
                      label: t("student.events.allCourses"),
                    },
                    ...filteredCourses.map((course: any) => ({
                      value: course.id,
                      label: course.fullname,
                    })),
                  ]}
                />
              </div>
              {isAllForumsLoading ? (
                <Skeleton height={130} className="mb-3" />
              ) : (
                <>
                  {currentForums.length > 0 ? (
                    currentForums.map((item: any, idx: any) => (
                      <ForumCard key={idx} forumData={item} />
                    ))
                  ) : (
                    <p>{t("student.forums.noForums")}</p>
                  )}
                </>
              )}
              {/* /pagination */}
              <Pagination
                totalItems={forumsArray.length}
                itemsPerPage={itemsPerPage}
                onPageChange={(page: number) => setCurrentPage(page)}
              />
              {/* /pagination */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentForums;
